module.exports = __webpack_public_path__ + "img/menu_2.d4f66790.png";